import { render, staticRenderFns } from "./ProofreadingSettingsDialog.vue?vue&type=template&id=ad3ae89e&scoped=true&"
import script from "./ProofreadingSettingsDialog.vue?vue&type=script&lang=ts&"
export * from "./ProofreadingSettingsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ProofreadingSettingsDialog.vue?vue&type=style&index=0&id=ad3ae89e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3ae89e",
  null
  
)

export default component.exports